/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetSitePortefeuilleResponseDto } from '../../models/get-site-portefeuille-response-dto';

export interface GetPortefeuilleV2$Params {
  /**
   * id_intervenant
   */
  id_intervenant: string;
  body: Array<string>;
}

export function getPortefeuilleV2(
  http: HttpClient,
  rootUrl: string,
  params: GetPortefeuilleV2$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>> {
  const rb = new RequestBuilder(rootUrl, getPortefeuilleV2.PATH, 'post');
  if (params) {
    rb.path('id_intervenant', params.id_intervenant, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GetSitePortefeuilleResponseDto>>;
    })
  );
}

getPortefeuilleV2.PATH = '/v2/portefeuille/{id_intervenant}';
